import {UseFormReturn, useForm} from 'hooks/custom-react-hook-form';

export const useGroupFilterForm = ({category}) => {
  let defaultValues = {
    minAge: [25],
    electro: false,
    extras: [],
    paymentEcOnly: false,
    category,
    premiumGroup: false,
    type: [],
    liftingPlatform: false,
    licence: [],
    price: [],
    // 0 = relevanz; -1 = preis aufsteigend ; 1 = preis absteigend
    sort: -1,
  };
  const formMethods = useForm({
    name: 'step1',
    defaultValues,
  });
  return {defaultValues, formMethods} as {
    defaultValues: TFormValues;
    formMethods: UseFormReturn<TFormValues>;
  };
};
export type TFormValues = {
  minAge: string | string[] | number[];
  electro: boolean;
  extras: any[];
  category: string;
  paymentEcOnly: boolean;
  premiumGroup: boolean;
  type: any[];
  liftingPlatform: boolean;
  licence: any[];
  price: any[];
  sort: number;
};
